module.exports = __webpack_public_path__ + "static/media/Open source-pana.b5db31af.png";